export default function TimerButton({ time }) {
    const formatTime = (seconds) => {
      if (seconds === null) return '04:00'; // výchozí hodnota
      const m = String(Math.floor(seconds / 60)).padStart(2, '0');
      const s = String(seconds % 60).padStart(2, '0');
      return `${m}:${s}`;
    };

    // Pokud time není null, znamená že odpočet začal nebo skončil — červená barva
    const isRed = time !== null;

    return (
      <button
        disabled
        className={`px-5 py-3 text-xl rounded-[60px] text-gray-50 ${
          isRed ? 'bg-red-600' : 'bg-[#0480B6]'
        }`}
      >
        Zbývající čas: {formatTime(time)}
      </button>
    );
  }
